var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 0H2C0.895431 0 0 0.895429 0 2V98C0 99.1046 0.895429 100 2 100H98C99.1046 100 100 99.1046 100 98V2C100 0.89543 99.1046 0 98 0Z",
    fill: "#010506"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6708 50.1287C41.5917 49.9443 41.5446 49.7481 41.5311 49.5486C41.5101 49.489 41.4992 49.4249 41.5002 49.3588C41.5075 48.9072 41.6966 48.4387 42.0541 48.0812L54.2823 35.853C55.0211 35.1142 56.18 35.1142 56.9188 35.853C57.6575 36.5917 57.6575 37.7507 56.9188 38.4894L47.083 48.3252C46.4972 48.911 46.4972 49.8607 47.083 50.4465L56.9459 60.3095C57.6847 61.0482 57.6847 62.2072 56.9459 62.9459C56.2072 63.6847 55.0482 63.6847 54.3095 62.9459L42.0872 50.7236C41.9089 50.5561 41.7672 50.3536 41.6708 50.1287Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBox);
export default __webpack_public_path__ + "static/media/left-arrow-box.a614f2f301d8c0b62548b968c0dc18ed.svg";
export { ForwardRef as ReactComponent };